import Index from "../../pages/snail/hlw/index";
import Help from "../../pages/snail/hlw/help";
import Pc from "../../pages/snail/hlw/pc";

const base = "hlw";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/help*`,
    name: `${base}-help`,
    component: Help
  },
  {
    path: `/${base}/pc`,
    name: `${base}-pc`,
    component: Pc
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/hlw.js